import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import getEnvConfig from 'utils/config/env';

import { SubscriptionProps } from '../interfaces';
import {
    SubscriptionPayload,
    SubscriptionResponse,
} from '../interfaces/subscription.interface';

export const subscriptionsApi = createApi({
    reducerPath: 'subscriptions',
    baseQuery: fetchBaseQuery({
        baseUrl: getEnvConfig().env.API_URL,
        prepareHeaders: headers => {
            const token = localStorage.getItem('accessToken');
            headers.set('Authorization', `Bearer ${token}`);
            return headers;
        },
    }),
    tagTypes: ['Subscription', 'User'],
    endpoints: builder => ({
        updateSubscription: builder.mutation<SubscriptionProps, any>({
            query: () => ({
                url: '/subscription/recurrent',
                method: 'PATCH',
            }),
            transformResponse: (response: { data: any }) => {
                return response.data;
            },
            invalidatesTags: ['Subscription', 'User'],
        }),
        checkSubscription: builder.query<any, void>({
            query: () => ({
                url: '/check/user/subscription',
            }),
            transformResponse: response => {
                return response;
            },
            providesTags: ['Subscription'],
        }),
        paySubscription: builder.mutation<
            SubscriptionResponse,
            SubscriptionPayload
        >({
            query: payload => ({
                url: '/subscription/pay',
                method: 'POST',
                body: { ...payload },
            }),
            transformResponse: (response: { data: SubscriptionResponse }) => {
                return response.data;
            },
        }),
        readSubscriptions: builder.query<SubscriptionProps[], void>({
            query: () => ({
                url: '/subscriptions_list',
            }),
            transformResponse: (response: { data: SubscriptionProps[] }) => {
                return response?.data;
            },
            providesTags: ['Subscription'],
        }),
    }),
});

export const {
    usePaySubscriptionMutation,
    useUpdateSubscriptionMutation,
    useCheckSubscriptionQuery,
    useReadSubscriptionsQuery,
} = subscriptionsApi;
